import { render, staticRenderFns } from "./ProfitStatementQuarter.vue?vue&type=template&id=2fa8e370&scoped=true"
import script from "./ProfitStatementQuarter.vue?vue&type=script&lang=js"
export * from "./ProfitStatementQuarter.vue?vue&type=script&lang=js"
import style0 from "./ProfitStatementQuarter.vue?vue&type=style&index=0&id=2fa8e370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8e370",
  null
  
)

export default component.exports